import type { FaireAdCampaignEntity } from "../../entity_types/adCampaign";

export const campP6ChurnedReorder: FaireAdCampaignEntity = {
  token: "camp_p6_churned_reorder",
  type: "adCampaign",
  advertiserProfileToken: "adv_p6_churned",
  segment: "REORDER_MARKETPLACE",
  status: "STOPPED",
  monthlyBudgetDollars: 600,
  startedRunningAt: "2025-02-15",
  stoppedRunningAt: "2026-07-01",
  segmentMetrics: {
    numReorderConversions: 87,
    salesDollars: 25705,
    totalAdsSpendDollars: 3747,
    returnOnAdSpend: 6.86,
  },
  performancePeriodTokens: [
    "perf_p6_churned_reorder_202506",
    "perf_p6_churned_reorder_202507",
    "perf_p6_churned_reorder_202508",
    "perf_p6_churned_reorder_202509",
    "perf_p6_churned_reorder_202510",
    "perf_p6_churned_reorder_202511",
    "perf_p6_churned_reorder_202512",
    "perf_p6_churned_reorder_202601",
    "perf_p6_churned_reorder_202602",
    "perf_p6_churned_reorder_202603",
    "perf_p6_churned_reorder_202604",
    "perf_p6_churned_reorder_202605",
    "perf_p6_churned_reorder_202606",
  ],
  meta: {
    source: "mock",
    importedAt: "2026-07-06T00:00:00.000Z",
    importedBy: "advertiser-profiles",
  },
};
